import {Link} from 'react-router-dom';
import React from 'react';

import {useracc, postApi, consoleLog} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import moment from 'moment';

import PaymentModule from '../payment/payment';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default class AccountInvoices extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			invoices: [],
			services: []
		};
    this.getInvoices = this.getInvoices.bind(this);
		this.invoiceAdmin = this.invoiceAdmin.bind(this);
  };

  async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		//this.getWebsites();

		

		//this.setState({status: true});
		//this.enable();

		this.getInvoices();

	}

	componentWillUnmount() {
	}


	async getInvoices(/*column = 'l.ctime', order = 'DESC'*/) {
		/*let sort = this.state.sort;
		sort.column = column;
		sort.order = order;*/
		let params = new URLSearchParams();
		//params.append('column', column);
		//params.append('order', order);
		const x = await postApi('/v3/account/invoices', params);
		consoleLog(x.data);
		if( x.status === 200 ) this.setState({status: true, invoices: x.data.invoices?x.data.invoices:[], services: x.data.services?x.data.services:[]});
	}


	async invoiceAdmin(service) {
		let services = this.state.services;
		let change = services.find(elem => elem.service === service);
		change.enabled = !change.enabled;
		this.setState({services});
		let params = new URLSearchParams();
		params.append('service', change.service);
		params.append('enabled', change.enabled);
		await postApi('/v3/account/invoiceadmin', params);
	}


	render() {
		const invoices = this.state.invoices.map((e,i) => {
			return (
        <tr key={i}>
          <td>
            <div className="d-flex align-items-center">
              <div className="me-2 lh-1">
                <span className="avatar avatar-sm avatar-rounded">
                  <img src={`https://cloud.ultrastream.io/${e.avatar}`} alt="" />
                </span>
              </div>
              <div>
                <p className="mb-0 fw-semibold">{e.title?e.title:e.username}</p>
                <p className="mb-0 fs-12 text-muted">{e.email}</p>
              </div>
            </div>
          </td>
          <td>
						<Link to={`/invoice/US${e.id}`}>
							<span style={{cursor: 'pointer', color: 'var(--primary-color)'}}>
								#US{e.id}
							</span>
						</Link>
          </td>
          <td>{moment(e.ctime).format("DD MMM YYYY")}</td>
          <td>
						{e.receipt==='0' ?
							<span className="badge bg-secondary-transparent fw-semibold fs-14">Not Paid</span>
						:
							<span className="badge bg-success-transparent fw-semibold fs-14">Paid</span>
						}
          </td>
          <td>£{e.total.toFixed(2)}</td>
        </tr>
			)
		});


		const services = this.state.services.map((e,i) => {
			return (
				<tr key={i}>
					<td>
						<div className={`toggle toggle-success mb-3 ${e.enabled===true?'on':''}`} onClick={()=>this.invoiceAdmin(e.service)}>
							<span></span>
						</div>
					</td>
					<td>
						{e.title}
					</td>
					
				</tr>
			)
		});
		

		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Invoices</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Invoices</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>

									
									<Col xs={12}>
									
										<div className="card custom-card overflow-hidden">
											<div className="card-header flex-between justify-content-between">
												<div className="card-title">Invoices</div>
											</div>
											<div className="card-body">
												<div className="table-responsive">
													<table className="table text-nowrap table-hover">
														<thead>
															<tr>
																<th scope="col">Client</th>
																<th scope="col">Invoice ID</th>
																<th scope="col">Issued Date</th>
																<th scope="col">Status</th>
																<th scope="col">Amount</th>
															</tr>
														</thead>
														<tbody>
															{invoices}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</Col>

									{services.length > 0 &&
										<Col xs={12}>
											<div className="card custom-card overflow-hidden">
												<div className="card-header flex-between justify-content-between">
													<div className="card-title">Shared Invoices</div>
												</div>
												<div className="card-body">
													<p>
														Share with your admin group to allow them to view and pay your invoices.
														<br />
														Any payment details such as bank/credit card details won't be shared.
													</p>
													<div className="table-responsive">
														<table className="table text-nowrap table-hover">
															<thead>
																<tr>
																	<th scope="col">Enabled</th>
																	<th scope="col">Service</th>
																</tr>
															</thead>
															<tbody>
																{services}
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</Col>
									}

									<Col xs={12}>
										
										<div className="card custom-card overflow-hidden">
											<div className="card-header justify-content-between">
												<div className="card-title">Payment Method</div>
											</div>
											<div className="card-body">
												<PaymentModule order={false} />
											</div>
										</div>
									</Col>
										
								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}
